<div class="user-project-detail-container">
  <app-tutorial-video-widget
    screenId="user-detailed-screen"
    title="User Project Detail walkthrough"
    teaserDescription="Watch a quick walkthrough of this screen."
    storageKey="user-detailed-screen-tutorial-seen"
    teaserPosition="bottom-right"
    launcherPosition="bottom-right"
    [autoPlaySequence]="userWorkflowTutorialSequence"
    [allowLauncherDismiss]="true">
  </app-tutorial-video-widget>

  <div class="top-row">
    <button class="btn btn-sm btn-outline-secondary back-btn" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ fromManageApproval ? 'Back to Manage Approval' : 'Back to Dashboard' }}
    </button>
  </div>

  <div class="projects-section" *ngIf="projectDetail as project; else noProject">
    <div class="section-head-row">
      <div class="action-header">
        <div class="section-title-row">
          <h2 class="section-title">Project Name : {{ project.name }}</h2>
          <!-- Status badge inline with project name when from user-dashboard -->
          <!-- <ng-container *ngIf="!fromManageApproval">
            <ng-container *ngIf="project.status === 'Pending RAES Review' && project.subTaskStatus !== 'APPROVED'; else inlineDefaultStatus">
              <span class="status-badge" [ngClass]="getStatusBadgeClass('Pending RRE Review')">Pending RRE Review</span>
            </ng-container>
            <ng-template #inlineDefaultStatus>
              <span class="status-badge" [ngClass]="getStatusBadgeClass(project.status)">{{ project.status }}</span>
            </ng-template>
          </ng-container> -->
          
          <ng-container *ngIf="!fromManageApproval">
            <div style="display: flex; flex-direction: row; gap: 10px;">
            <button class="btn pill-btn flex-shrink-0 refresh" (click)="reloadPage()" title="Refresh">
              <mat-icon>refresh</mat-icon>
            </button>
            <span class="status-badge" [ngClass]="getStatusBadgeClass(getTopStatusLabel(project))">{{ getTopStatusLabel(project)
              }}</span>
            </div>
          </ng-container>
        </div>
        <!-- Status inline for normal view, on separate line when coming from Manage Approval -->

        <div class="section-actions">
          <ng-container *ngIf="!alreadyActionedOnOpen && project.subTaskStatus !== 'APPROVED' && project.subTaskStatus !== 'REJECTED'">
            <button type="button" *ngIf="fromManageApproval" class="br btn btn-sm btn-outline-danger"
              (click)="onRejectFromManageApproval()"><mat-icon>close</mat-icon>
              Rework
            </button>
            <button type="button" *ngIf="fromManageApproval" class="action br btn btn-sm btn-danger"
              (click)="onApproveFromManageApproval()"><mat-icon>check</mat-icon>
              Approve
            </button>
          </ng-container>
          <!-- <div class="approval-status-indicator approved"
            *ngIf="fromManageApproval && project.subTaskStatus === 'APPROVED'">
            <mat-icon class="approval-status-icon">check_circle</mat-icon>
            <span class="approval-status-label">Approved</span>
          </div>
          <div class="approval-status-indicator rework"
            *ngIf="fromManageApproval && project.subTaskStatus === 'REWORK'">
            <mat-icon class="approval-status-icon">cancel</mat-icon>
            <span class="approval-status-label">Rework</span>
          </div> -->
        </div>


      </div>
      <!-- Status on separate line only when coming from Manage Approval -->
      <div class="status-line" *ngIf="fromManageApproval">
        <ng-container *ngIf="project.subTaskStatus === 'APPROVED' && !alreadyActionedOnOpen; else rreReviewStatus">
          <span class="status-badge" [ngClass]="getStatusBadgeClass('Pending RAES Review')">Pending RAES Review</span>
        </ng-container>
        <ng-template #rreReviewStatus>
          <ng-container
            *ngIf="alreadyActionedOnOpen || project.status === 'Pending RAES Review' || isReworkState(project); else defaultStatus">
            <span class="status-badge" [ngClass]="getStatusBadgeClass('Pending RRE Review')">Pending RRE Review</span>
          </ng-container>
          <ng-template #defaultStatus>
            <span class="status-badge" [ngClass]="getStatusBadgeClass(project.subTaskStatus)">{{
              project.subTaskStatus}}</span>
          </ng-template>
        </ng-template>
      </div>
    </div>

    <!-- Approval / Rejection Confirmation Dialog (Material styled) -->
    <div class="approval-dialog-backdrop" *ngIf="showApprovalDialog">
      <div class="approval-dialog" (click)="$event.stopPropagation()">
        <div class="approval-dialog-header">
          <div class="approval-dialog-icon-wrap" [class.approve]="approvalDialogMode === 'approved'" [class.reject]="approvalDialogMode === 'rework'">
            <mat-icon>{{ approvalDialogMode === 'approved' ? 'check_circle' : 'cancel' }}</mat-icon>
          </div>
          <div class="approval-dialog-header-text">
            <h3 class="approval-dialog-title">
              {{ approvalDialogMode === 'approved' ? 'Approve Request' : 'Rework Request' }}
            </h3>
          </div>
          <button type="button" class="approval-dialog-close" (click)="cancelApprovalDialog()" aria-label="Close">&times;</button>
        </div>
        <hr class="approval-dialog-divider">

        <p class="approval-dialog-message">
          Are you sure you want to
          {{ approvalDialogMode === 'approved' ? 'approve' : 'marked for rework' }}
          this request?
        </p>

        <div class="approval-dialog-field">
          <label class="approval-comment-label">Add Comment</label>
          <textarea class="approval-comment-textarea" rows="3" [(ngModel)]="approvalComment"
            [placeholder]="approvalDialogMode === 'approved' ? 'Optional comment for approval...' : 'Comment is required to request rework...'"></textarea>
          <span class="approval-comment-error"
            *ngIf="approvalDialogMode === 'rework' && !(approvalComment || '').trim()">
            **Comment is required to request rework.
          </span>
        </div>

        <div class="approval-dialog-actions">
          <button type="button" class="approval-btn-cancel" (click)="cancelApprovalDialog()">
            Cancel
          </button>
          <button class="approval-btn-confirm" type="button"
            [disabled]="approvalDialogMode === 'rework' && !(approvalComment || '').trim()"
            (click)="confirmApprovalDialog()">
            {{ approvalDialogMode === 'approved' ? 'Approve' : 'Rework' }}
          </button>
        </div>
      </div>
    </div>

    <div class="approval-dialog-backdrop" *ngIf="showApprovalResultDialog">
      <div class="approval-result-dialog" (click)="$event.stopPropagation()">
        <div class="approval-result-icon-wrap" [ngClass]="approvalResultType === 'approved' ? 'approved' : 'rejected'">
          <mat-icon class="approval-result-icon">{{ approvalResultType === 'approved' ? 'check_circle' : 'cancel'
            }}</mat-icon>
        </div>

        <h3 class="approval-result-title">{{ approvalResultType === 'approved' ? 'Request Approved' : 'Marked for rework'
          }}
        </h3>
        <p class="approval-result-message">
          {{ approvalResultType === 'approved'
          ? 'Project is now moved to RAES review.'
          : 'Project has been sent back for rework.' }}
        </p>

        <div class="approval-next-step-card">
          <div class="approval-next-step-icon-wrap">
            <span class="approval-next-step-arrow" aria-hidden="true">➜</span>
          </div>
          <div class="approval-next-step-content">
            <div class="approval-next-step-title">NEXT STEP</div>
            <p class="approval-result-instruction">
              {{ approvalResultType === 'approved'
              ? 'RAES team will review the submitted documents and update the final status.'
              : 'Assignee should address comments, update document status and resubmit for review!' }}
            </p>
          </div>
        </div>

        <p class="approval-result-contact">For more details contact <b>{{ approvalResultType === 'approved' ? project.contactPerson : selectedMemberName }}</b>.</p>

        <div class="approval-result-actions">
          <button class="action br btn btn-sm btn-danger" type="button" (click)="closeApprovalResultDialog()">
            Got it
          </button>
        </div>
      </div>
    </div>

    <!-- Already Actioned Dialog (shown when a Manage Approval link is opened after the request was already reviewed) -->
    <div class="approval-dialog-backdrop" *ngIf="showAlreadyApprovedDialog">
      <div class="approval-result-dialog" (click)="$event.stopPropagation()">
        <div class="approval-result-icon-wrap" [ngClass]="alreadyActionedType === 'rework' ? 'rejected' : 'approved'">
          <mat-icon class="approval-result-icon">{{ alreadyActionedType === 'rework' ? 'cancel' : 'check_circle'
            }}</mat-icon>
        </div>

        <h3 class="approval-result-title">
          {{ alreadyActionedType === 'rework' ? 'Request Already Sent for Rework' : 'Request Already Approved' }}
        </h3>
        <p class="approval-result-message">
          This project has already been {{ alreadyActionedType === 'rework' ? 'sent back for rework' : 'approved' }}.
          Please check the User Dashboard for the latest status.
        </p>

        <div class="approval-next-step-card">
          <div class="approval-next-step-icon-wrap">
            <span class="approval-next-step-arrow" aria-hidden="true">➜</span>
          </div>
          <div class="approval-next-step-content">
            <div class="approval-next-step-title">NEXT STEP</div>
            <p class="approval-result-instruction">
              {{ alreadyActionedType === 'rework'
              ? 'The assignee has been notified to address the feedback and resubmit for review.'
              : 'The RAES team will review the submitted documents and update the final status.' }}
            </p>
          </div>
        </div>

        <p class="approval-result-contact">For more details contact <b>{{ project.contactPerson }}</b>.</p>

        <div class="approval-result-actions">
          <button class="action br btn btn-sm btn-danger" type="button" (click)="dismissAlreadyApprovedDialog()">
            View Project Details
          </button>
        </div>
      </div>
    </div>

    <!-- Delete File Confirmation Dialog -->
    <div class="confirm-overlay" *ngIf="showDeleteFileDialog">
      <div class="confirm-box">
        <div class="confirm-title">Confirm Action</div>
        <div class="confirm-content">
          <p class="confirm-text">Are you sure you want to delete this document <strong class="confirm-project-name">{{
              deleteFileDetails.fileName }}</strong>?</p>
        </div>
        <div class="confirm-dialog-actions">
          <button type="button" class="btn btn-cancel" (click)="closeDeleteFileDialog()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmDeleteFile()">Delete</button>
        </div>
      </div>
    </div>

    <div class="workflow-panel" aria-label="Project workflow progress">
      <div class="workflow-panel-head">
        <h3 class="workflow-title">Progress Bar</h3>
        <span class="workflow-percent">{{ getWorkflowProgressPercent(project) }}%</span>
      </div>

      <div class="workflow-track" role="progressbar" [attr.aria-valuenow]="getWorkflowProgressPercent(project)"
        aria-valuemin="0" aria-valuemax="100">
        <div class="workflow-track-fill" [style.width.%]="getWorkflowProgressBarWidth(project)"></div>
      </div>

      <div class="workflow-steps">
        <div *ngFor="let step of workflowSteps; let index = index" class="workflow-step"
          [ngClass]="getWorkflowStepClass(project, index)">
          <div class="workflow-step-dot"></div>
          <div class="workflow-step-label">{{ step }}</div>
        </div>
      </div>
    </div>

    <div class="detail-grid">
      <div class="detail-column detail-column-left">
        <div class="detail-panel">
          <h3 class="panel-title">Collection Overview</h3>

          <div class="collection-split">
            <div class="meta-block mb-0">
              <div class="meta-label">Collection Name</div>
              <div class="meta-item-row">
                <mat-icon>folder_open</mat-icon>
                <span>{{ project.collection }}</span>
              </div>
            </div>

            <div class="meta-block mb-0">
              <div class="meta-label">Sub Collections</div>
              <div class="meta-item-row" *ngFor="let subCollection of project.subCollections">
                <mat-icon>folder</mat-icon>
                <span>{{ subCollection }}</span>
              </div>
            </div>
          </div>

          <div class="section-divider"></div>

          <h4 class="sub-panel-title">Project Information</h4>
          <div class="project-info-grid">
            <div class="project-info-item">
              <div class="project-info-head">
                <mat-icon class="project-info-icon">apartment</mat-icon>
                <span class="project-info-key">Department Assigned</span>
              </div>
              <div class="project-info-val">{{ project.departmentAssigned }}</div>
            </div>

            <div class="project-info-item">
              <div class="project-info-head">
                <mat-icon class="project-info-icon">person</mat-icon>
                <span class="project-info-key">Contact Person</span>
              </div>
              <div class="project-info-val">{{ project.contactPerson }}</div>
            </div>

            <div class="project-info-item">
              <div class="project-info-head">
                <mat-icon class="project-info-icon">event</mat-icon>
                <span class="project-info-key">Due Date</span>
              </div>
              <div class="project-info-val">{{ formatDate(project.dueDate) }}</div>
            </div>

            <div class="project-info-item">
              <div class="project-info-head">
                <mat-icon class="project-info-icon">tag</mat-icon>
                <span class="project-info-key">Document Number</span>
              </div>
              <div class="project-info-val">{{ project.documentNumber }}</div>
            </div>
          </div>
        </div>

        <div class="detail-panel email-layout-card">
          <h3 class="panel-title">Email Details</h3>

          <div class="email-detail-row">
            <div class="email-detail-label">Subject</div>
            <div class="email-detail-value-box">
              <div class="email-detail-value">
                {{ project.subject || 'Not available' }}
              </div>
            </div>
          </div>

          <div class="email-detail-row email-content-row mb-0">
            <div class="email-detail-label">Email Content</div>
            <div class="email-detail-value-box">
              <div class="email-detail-value">
                <div class="email-content-preview NgxEditor__Content" [innerHTML]="project.email_body"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Activity Timeline Section - Modern Design -->
        <div class="detail-panel activity-timeline-panel">
          <div class="activity-modern-header" (click)="isActivityTimelineExpanded = !isActivityTimelineExpanded">
            <div class="activity-header-content">
              <h3 class="panel-title">Activity Timeline</h3>
              <span class="activity-count-badge" *ngIf="activityStreamData !== null && activityStreamData.length > 0">
                {{ activityStreamData.length }}
              </span>
            </div>
            <mat-icon class="expand-toggle"
              [style.transform]="isActivityTimelineExpanded ? 'rotate(180deg)' : 'rotate(0deg)'">
              expand_more
            </mat-icon>
          </div>

          <div class="activity-timeline-content" *ngIf="isActivityTimelineExpanded">
            <!-- Loading State -->
            <div *ngIf="activityStreamData === null" class="activity-loading-state">
              <div class="loading-spinner"></div>
              <p>Loading activities...</p>
            </div>

            <!-- Activity Items -->
            <div *ngIf="activityStreamData !== null && activityStreamData.length > 0" class="activity-timeline-list">
              <div class="activity-timeline-item"
                *ngFor="let activity of getSortedActivities(); let isFirst = first; let isLast = last">
                <!-- Timeline Line -->
                <div class="timeline-line-wrapper">
                  <div class="timeline-line" [class.first]="isFirst" [class.last]="isLast"></div>
                  <div class="timeline-dot" [ngClass]="'activity-type-' + getActivityIconType(activity)">
                    <mat-icon [ngSwitch]="getActivityIconType(activity)">
                      <ng-container *ngSwitchCase="'assigned'">person_add</ng-container>
                      <ng-container *ngSwitchCase="'completed'">check_circle</ng-container>
                      <ng-container *ngSwitchCase="'reviewed'">check_circle</ng-container>
                      <ng-container *ngSwitchCase="'upload'">cloud_upload</ng-container>
                      <ng-container *ngSwitchCase="'delete'">delete</ng-container>
                      <ng-container *ngSwitchCase="'rework'">refresh</ng-container>
                      <ng-container *ngSwitchCase="'rre-review'">visibility_check</ng-container>
                      <ng-container *ngSwitchCase="'comment'">chat_bubble</ng-container>
                      <ng-container *ngSwitchCase="'escalation'">warning</ng-container>
                      <ng-container *ngSwitchCase="'reminder'">notifications</ng-container>
                      <ng-container *ngSwitchCase="'skip'">skip_next</ng-container>
                      <ng-container *ngSwitchCase="'status-update'">published_with_changes</ng-container>
                      <ng-container *ngSwitchDefault>timeline</ng-container>
                    </mat-icon>
                  </div>
                </div>

                <!-- Activity Content -->
                <div class="activity-content-wrapper">
                  <div class="activity-content-card">
                    <!-- Activity Header -->
                    <div class="activity-header-row">
                      <div class="activity-user-info">
                        <div class="user-details">
                          <span class="user-name">{{ activity.user_name || activity.created_by }}</span>
                          <span class="activity-type-badge" [ngClass]="'badge-' + getActivityIconType(activity)">
                            {{ getActivityTypeLabel(activity) }}
                          </span>
                        </div>
                      </div>
                      <div class="activity-time">
                        {{ getRelativeTime(activity.created_at) }}
                      </div>
                    </div>

                    <!-- Activity Description -->
                    <div class="activity-description" *ngIf="activity.activity_description">
                      {{ activity.activity_description }}
                    </div>

                    <!-- Activity Comment -->
                    <div class="activity-comment-section" *ngIf="hasComments(activity)">
                      <div class="comment-icon">
                        <mat-icon>format_quote</mat-icon>
                      </div>
                      <div class="comment-text">{{ activity.user_comments }}</div>
                    </div>

                    <!-- Activity Footer -->
                    <div class="activity-footer">
                      <span class="activity-timestamp">
                        {{ activity.created_at | date:'MMM d, yyyy · hh:mm a' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="activityStreamData !== null && activityStreamData.length === 0" class="activity-empty-state">
              <div class="empty-state-icon">
                <mat-icon>history</mat-icon>
              </div>
              <h4 class="empty-state-title">No Activity Yet</h4>
              <p class="empty-state-message">Activity timeline will appear here as actions are performed on this project
              </p>
            </div>

            <div class="activity-comment-composer" *ngIf="projectDetail?.status !== 'Completed'">
              <div class="d-flex align-items-center gap-2">
                <input
                  type="text"
                  class="form-control activity-comment-input"
                  [(ngModel)]="newActivityComment"
                  placeholder="Add your review comment..."
                  (keydown.enter)="postActivityComment()"
                />
                <button
                  type="button"
                  class="btn btn-action-primary activity-send-btn"
                  [disabled]="!newActivityComment || !newActivityComment.trim()"
                  (click)="postActivityComment()"
                  matTooltip="Send"
                >
                  <mat-icon>send</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-column detail-column-right">

        <!-- <div class="stepper-panel-header">
            <h3 class="panel-title stepper-main-title">Action Steps</h3>
            <p class="stepper-subtitle">Complete each step to progress this project</p>
          </div> -->

        <div class="action-stepper">
          <!-- Step 1: Task Assignment -->
          <div class="stepper-step" [class.step-completed]="isStepCompleted(1)"
            [class.step-active]="activeStepperStep === 1 && !isStepCompleted(1)"
            [class.step-current]="activeStepperStep === 1">
            <div class="stepper-step-header" (click)="onStepperStepClick(1)">
              <div class="stepper-step-indicator">
                <div class="step-circle">
                  <mat-icon *ngIf="isStepCompleted(1)">check</mat-icon>
                  <span *ngIf="!isStepCompleted(1)">1</span>
                </div>
                <div class="step-connector"></div>
              </div>
              <div class="stepper-step-title-area">
                <div class="stepper-step-label">Step 1</div>
                <div class="stepper-step-title">Task Assignment</div>
                <div class="stepper-step-summary completed-summary"
                  *ngIf="isStepCompleted(1) && activeStepperStep !== 1">
                  <mat-icon class="summary-icon">person</mat-icon>
                  Assigned to <strong>{{ selectedMemberName }}</strong>
                </div>
              </div>
              <mat-icon class="stepper-chevron">{{ activeStepperStep === 1 ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>

            <div class="stepper-step-content" *ngIf="activeStepperStep === 1">
              <div class="stepper-step-body">
                <div class="assignment-header">
                  <div class="assignment-header-main">
                    <div class="panel-title">Task Assignment</div>
                    <div class="assignment-owner-line">
                      <span class="owner-label">Current owner:</span>
                      <span class="owner-value">{{ selectedMemberName ? selectedMemberName : 'Unassigned' }}</span>
                    </div>
                  </div>
                  <button
                    *ngIf="!showAssignmentPanel && (project.subTaskStatus !== 'Pending RRE Review' && project.subTaskStatus !== 'Pending RAES Approve' && project.subTaskStatus !== 'Completed' && project.subTaskStatus !== 'Pending RAES Review')"
                    type="button" class="btn btn-change-assignee" (click)="toggleAssignmentPanel(true)">
                    <mat-icon>{{ selectedMemberName ? 'edit' : 'person_add' }}</mat-icon>
                    {{ selectedMemberName ? 'Change Assignee' : 'Assign Owner' }}
                  </button>
                  <button *ngIf="showAssignmentPanel" type="button" class="btn btn-close-panel-header"
                    (click)="toggleAssignmentPanel()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>

                <div class="assignment-panel-expanded" *ngIf="showAssignmentPanel">
                  <!-- Step 1: Choose Assignment Type -->
                  <div class="assignment-step">
                    <h4 class="step-title" *ngIf="!fromManageApproval">
                      <span class="step-number">1</span>
                      How would you like to assign this project?
                    </h4>
                    <div class="assignment-cards-grid">
                      <div class="assignment-card" *ngIf="!fromManageApproval"
                        [class.assignment-card--active]="assignmentMode === 'self'" (click)="setAssignmentMode('self')"
                        role="button" tabindex="0">
                        <div class="card-icon-wrapper">
                          <div class="card-icon">
                            <mat-icon>person_outline</mat-icon>
                          </div>
                        </div>
                        <div class="card-content">
                          <h5 class="card-title">Assign to Myself</h5>
                          <p class="card-description">The project will be assigned to your account</p>
                        </div>
                      </div>

                      <div class="assignment-card" [class.assignment-card--active]="assignmentMode === 'others'"
                        (click)="setAssignmentMode('others')" role="button" tabindex="0">
                        <div class="card-icon-wrapper">
                          <div class="card-icon">
                            <mat-icon>group_outline</mat-icon>
                          </div>
                        </div>
                        <div class="card-content">
                          <h5 class="card-title">Assign to a Team Member</h5>
                          <p class="card-description">Select someone from your department</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Step 2: Self Assignment Confirmation -->
                  <div *ngIf="assignmentMode === 'self'" class="assignment-step assignment-step-self"
                    [@.disabled]="false">
                    <h4 class="step-title">
                      <span class="step-number">2</span>
                      Confirm Assignee
                    </h4>
                    <div class="self-assignment-info">
                      <div class="info-box">
                        <mat-icon>info</mat-icon>
                        <p>This project will be assigned to your account and you'll be responsible.</p>
                      </div>
                    </div>
                    <div class="button-group">
                      <button class="btn btn-cancel" (click)="toggleAssignmentPanel()">

                        <span>Cancel</span>
                      </button>
                      <button class="btn btn-confirm-primary" (click)="assignToMember(true)">
                        <span>Confirm</span>
                      </button>
                    </div>
                  </div>

                  <!-- Step 2: Select Member -->
                  <div *ngIf="assignmentMode === 'others'" class="assignment-step assignment-step-others">
                    <h4 class="step-title">
                      <span class="step-number">{{ fromManageApproval ? 1 : 2 }}</span>
                      Select a Team Member
                    </h4>

                    <div class="members-search-wrapper">
                      <input type="text" class="members-search-input" placeholder="Search by name or email..."
                        #searchInput (keyup)="onMemberSearch($event)" />
                      <mat-icon class="search-icon">search</mat-icon>
                    </div>

                    <div class="members-cards-grid">
                      <div *ngFor="let member of getFilteredMembers()" class="member-card"
                        [class.member-card--selected]="selectedMemberId === member.email" (click)="selectMember(member)"
                        role="button" tabindex="0">
                        <div class="member-card-content">
                          <div class="selection-check" *ngIf="selectedMemberId === member.email">
                            <mat-icon>check</mat-icon>
                          </div>
                          <div class="member-details">
                            <h5 class="member-name">{{ member.name }}</h5>
                            <p class="member-job-title">{{ member.jobTitle }}</p>
                            <p class="member-email">{{ member.email }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="getFilteredMembers().length === 0" class="no-members-found">
                      <mat-icon>group_off</mat-icon>
                      <p>No team members found</p>
                    </div>

                    <div class="button-group">
                      <button class="btn btn-cancel" (click)="toggleAssignmentPanel()">

                        <span>Cancel</span>
                      </button>
                      <button class="btn btn-confirm-primary" [disabled]="!selectedMemberId" (click)="assignToMember()">
                        <span>Confirm : {{ getSelectedMemberName() }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2: Update Document Status -->
            <div class="stepper-step" [class.step-completed]="isStepCompleted(2)"
              [class.step-active]="activeStepperStep === 2 && !isStepCompleted(2)"
              [class.step-locked]="!isStepAccessible(2)" [class.step-current]="activeStepperStep === 2">
              <div class="stepper-step-header" (click)="onStepperStepClick(2)">
                <div class="stepper-step-indicator">
                  <div class="step-circle">
                    <mat-icon *ngIf="isStepCompleted(2)">check</mat-icon>
                    <mat-icon *ngIf="!isStepCompleted(2) && !isStepAccessible(2)">lock</mat-icon>
                    <span *ngIf="!isStepCompleted(2) && isStepAccessible(2)">2</span>
                  </div>
                  <div class="step-connector" *ngIf="!fromManageApproval"></div>
                </div>
                <div class="stepper-step-title-area">
                  <div class="stepper-step-label">Step 2</div>
                  <div class="stepper-step-title">Update Document Status</div>
                  <div class="stepper-step-summary locked-summary" *ngIf="!isStepAccessible(2)">
                    <mat-icon class="summary-icon">info_outline</mat-icon>
                    Complete Step 1 first
                  </div>
                  <div class="stepper-step-summary completed-summary"
                    *ngIf="isStepCompleted(2) && activeStepperStep !== 2">
                    <mat-icon class="summary-icon">check_circle</mat-icon>
                    All statuses updated
                  </div>
                </div>
                <mat-icon class="stepper-chevron" *ngIf="isStepAccessible(2)">{{ activeStepperStep === 2 ? 'expand_less'
                  : 'expand_more' }}</mat-icon>
              </div>

              <div class="stepper-step-content" *ngIf="activeStepperStep === 2 && isStepAccessible(2)">
                <div class="stepper-step-body">
                  <div *ngIf="project.uploadedFilesData && project.uploadedFilesData.length > 0">
                    <h3 class="panel-title">Documents Requested</h3>

                    <div class="documents-sections-wrapper">
                      <!-- Each Document Section -->
                      <div class="document-section-card" *ngFor="let file of project.uploadedFilesData"
                        (click)="toggleFileExpand(file.fileId)">

                        <!-- Section Header (Always Visible) -->
                        <div class="section-header" [class.expanded]="expandedFileId === file.fileId">
                          <div class="header-left">
                            <mat-icon class="expand-toggle"
                              [style.transform]="expandedFileId === file.fileId ? 'rotate(180deg)' : 'rotate(0deg)'">
                              expand_more
                            </mat-icon>
                            <ng-container [ngSwitch]="iconType(file.fileName)">
                              <svg *ngSwitchCase="'pdf'" width="24" height="24" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#ef4444" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
                                class="section-file-icon">
                                <path
                                  d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                                </path>
                                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                                <path d="M10 9H8"></path>
                                <path d="M16 13H8"></path>
                                <path d="M16 17H8"></path>
                              </svg>
                              <svg *ngSwitchCase="'xls'" width="24" height="24" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#10b981" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
                                class="section-file-icon">
                                <path
                                  d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                                </path>
                                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                                <path d="M10 9H8"></path>
                                <path d="M16 13H8"></path>
                                <path d="M16 17H8"></path>
                              </svg>
                              <svg *ngSwitchCase="'doc'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" aria-hidden="true" class="section-file-icon">
                                <path
                                  d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                                </path>
                                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                                <path d="M10 9H8"></path>
                                <path d="M16 13H8"></path>
                                <path d="M16 17H8"></path>
                              </svg>
                              <svg *ngSwitchCase="'image'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" aria-hidden="true" class="section-file-icon">
                                <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                                <circle cx="9" cy="9" r="2"></circle>
                                <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                              </svg>
                              <svg *ngSwitchDefault width="24" height="24" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#6366f1" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
                                class="section-file-icon">
                                <path
                                  d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                                </path>
                                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                              </svg>
                            </ng-container>
                            <div class="file-info">
                              <h4 class="file-name">{{ file.fileName }}</h4>
                            </div>
                          </div>
                          <div class="header-right" *ngIf="file.versions && file.versions.length > 0">
                            <!-- Display mode: status is set and not editing -->
                            <ng-container
                              *ngIf="getDocumentMarkStatus(project, file.fileName) && !documentStatusEditing[file.fileName]">
                              <span class="status-badge-header"
                                [ngClass]="getStatusBadgeClass(getDocumentMarkStatus(project, file.fileName))">
                                {{ getDocumentMarkStatus(project, file.fileName) }}
                              </span>
                              <button type="button" class="status-edit-btn"
                                *ngIf="!fromManageApproval && !areAllStepsCompleted() && project.subTaskStatus !== 'Pending RAES Review' && project.subTaskStatus !== 'Pending RRE Review'"
                                (click)="documentStatusEditing[file.fileName] = true; $event.stopPropagation()"
                                title="Edit status">
                                <mat-icon class="edit-icon">edit</mat-icon>
                              </button>
                            </ng-container>
                            <!-- Edit mode: no status yet or currently editing -->
                            <ng-container
                              *ngIf="!fromManageApproval && !areAllStepsCompleted() && (!getDocumentMarkStatus(project, file.fileName) || documentStatusEditing[file.fileName])">
                              <select class="status-dropdown" [(ngModel)]="documentStatusPending[file.fileName]"
                                (click)="$event.stopPropagation()" (change)="$event.stopPropagation()">
                                <option class="status" value="" disabled selected>Select status</option>
                                <option value="No Change Required">No Change Required</option>
                                <option value="Not Responsible">Not Responsible</option>
                                <option value="Completed">Completed</option>
                              </select>
                              <button type="button" class="status-confirm-btn"
                                [disabled]="!documentStatusPending[file.fileName]"
                                (click)="confirmDocumentStatus(project, file.fileName); $event.stopPropagation()">
                                Confirm
                              </button>
                            </ng-container>
                          </div>
                        </div>

                        <!-- Expanded Section Content -->
                        <div class="section-content" *ngIf="expandedFileId === file.fileId"
                          (click)="$event.stopPropagation()">



                          <!-- Version History -->
                          <div class="version-history-section" *ngIf="file.versions && file.versions.length > 0">
                            <!-- <div class="history-header">
                    <h5 class="version-history-title">Upload History</h5>
                  
                  </div> -->

                            <div class="version-timeline">
                              <div class="version-timeline-item"
                                *ngFor="let version of file.versions; let first = first"
                                [class.is-latest]="version.isLatest">
                                <!-- Timeline Dot -->
                                <div class="timeline-dot" [class.latest-dot]="version.isLatest">
                                  <mat-icon class="timeline-icon" *ngIf="version.isLatest">check_circle</mat-icon>
                                  <mat-icon class="timeline-icon" *ngIf="!version.isLatest">cloud_done</mat-icon>
                                </div>

                                <!-- Version Card -->
                                <div class="version-card" [class.latest-card]="version.isLatest">
                                  <div class="card-header">
                                    <div class="version-badge-group">
                                      <span class="version-label">Version {{ version.versionNumber }}</span>
                                      <span *ngIf="version.isLatest" class="latest-badge">
                                        <mat-icon>star</mat-icon>
                                        Latest
                                      </span>
                                    </div>
                                    <div class="card-actions">
                                      <button class="card-action-btn" title="View version" [matTooltip]="'View'"
                                        (click)="preview(version)">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#374151"
                                            stroke-width="1.5" fill="none" stroke-linecap="round"
                                            stroke-linejoin="round"></path>
                                          <circle cx="12" cy="12" r="2.5" stroke="#374151" stroke-width="1.5"></circle>
                                        </svg>
                                      </button>
                                      <button class="card-action-btn" title="Download version" [matTooltip]="'Download'"
                                        (click)="download(version)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                          viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                          <path d="M12 15V3"></path>
                                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                          <path d="m7 10 5 5 5-5"></path>
                                        </svg>
                                      </button>
                                      <button class="card-action-btn" title="Delete version" [matTooltip]="'Delete'"
                                        *ngIf="canDeleteFile(version) && !fromManageApproval && !areAllStepsCompleted() && project.subTaskStatus !== 'Pending RRE Review' && project.subTaskStatus !== 'Pending RAES Review'"
                                        (click)="deleteFile(version.fileVersioningId, version.fileName); $event.stopPropagation()"
                                        style="color: #dc2626;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                          <polyline points="3 6 5 6 21 6"></polyline>
                                          <path
                                            d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                          </path>
                                          <line x1="10" y1="11" x2="10" y2="17"></line>
                                          <line x1="14" y1="11" x2="14" y2="17"></line>
                                        </svg>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="card-meta">
                                    <div class="meta-item">
                                      <span class="meta-icon">
                                        <mat-icon>file</mat-icon>
                                      </span>
                                      <div class="meta-content">
                                        <span class="meta-label">File Name</span>
                                        <span class="meta-value">{{ version.fileName }}</span>
                                      </div>
                                    </div>
                                    <div class="meta-item">
                                      <span class="meta-icon">
                                        <mat-icon>person_outline</mat-icon>
                                      </span>
                                      <div class="meta-content">
                                        <span class="meta-label">Uploaded By</span>
                                        <span class="meta-value">{{ version.uploadedBy }}</span>
                                      </div>
                                    </div>
                                    <div class="meta-item">
                                      <span class="meta-icon">
                                        <mat-icon>event_note</mat-icon>
                                      </span>
                                      <div class="meta-content">
                                        <span class="meta-label">Date & Time</span>
                                        <span class="meta-value">{{ version.uploadDate }} at {{ version.uploadTime
                                          }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Upload New Version Area -->
                          <div class="upload-area" *ngIf="!fromManageApproval && !areAllStepsCompleted() && project.subTaskStatus !== 'Pending RAES Review' && project.subTaskStatus !== 'Pending RRE Review'">
                            <button class="upload-btn" type="button"
                              (click)="triggerFileUpload(file.fileId, 'new-version'); $event.stopPropagation()">
                              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" aria-hidden="true">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="17 8 12 3 7 8"></polyline>
                                <line x1="12" y1="3" x2="12" y2="15"></line>
                              </svg>
                              Upload New Version
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Hidden File Input -->
                    <input type="file" #documentFileInput hidden (change)="handleDocumentFileUpload($event)"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.xlsm,.jpg,.jpeg,.png,.csv">
                  </div>

                  <div
                    *ngIf="!projectDetail?.uploadedFilesData || projectDetail?.uploadedFilesData?.length === 0">
                    <h3 class="panel-title">Documents Requested</h3>
                    <div class="documents-sections-wrapper">
                      <div class="document-section-card">
                        <!-- Section Header -->
                        <div class="section-header">
                          <div class="header-left">
                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                              fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" aria-hidden="true" class="section-file-icon">
                              <path
                                d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                              </path>
                              <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                            </svg>
                            <div class="file-info">
                              <h4 class="file-name">No document requested</h4>
                            </div>
                          </div>
                          <div class="header-right">
                            <!-- Read-only badge when viewing from Manage Approval -->
                            <ng-container *ngIf="fromManageApproval && projectDetail?.noDocumentUploadsStatus">
                              <span class="status-badge-header"
                                [ngClass]="getStatusBadgeClass(projectDetail?.noDocumentUploadsStatus)">
                                {{ projectDetail?.noDocumentUploadsStatus }}
                              </span>
                            </ng-container>
                            <!-- Display mode: status is set and not editing -->
                            <ng-container
                              *ngIf="!fromManageApproval && (projectDetail?.noDocumentUploadsStatus || statusSubmittedForApproval) && !documentStatusEditing['__no_docs__']">
                              <span class="status-badge-header"
                                [ngClass]="projectDetail?.noDocumentUploadsStatus ? getStatusBadgeClass(projectDetail?.noDocumentUploadsStatus) : getSubmittedStatusClass()">
                                {{ projectDetail?.noDocumentUploadsStatus || getSubmittedStatusLabel() }}
                              </span>
                              <button type="button" class="status-edit-btn" *ngIf="!fromManageApproval && !areAllStepsCompleted() && project.subTaskStatus !== 'Pending RRE Review' && project.subTaskStatus !== 'Pending RAES Review' && project.subTaskStatus !== 'Completed'"
                                (click)="documentStatusEditing['__no_docs__'] = true; $event.stopPropagation()"
                                title="Edit status">
                                <mat-icon class="edit-icon">edit</mat-icon>
                              </button>
                            </ng-container>
                            <!-- Edit mode: no status yet or currently editing -->
                            <ng-container
                              *ngIf="!fromManageApproval && !areAllStepsCompleted() && projectDetail?.subTaskStatus !== 'Completed' && ((!projectDetail?.noDocumentUploadsStatus && !statusSubmittedForApproval) || documentStatusEditing['__no_docs__'])">
                              <select class="status-dropdown" [ngModel]="selectedProjectStatus"
                                (ngModelChange)="selectProjectStatus($event)" (click)="$event.stopPropagation()">
                                <option value="" disabled selected>Select status</option>
                                <option value="no-change">No Change Required</option>
                                <option value="not-responsible">Not Responsible</option>
                                <option value="completed">Completed</option>
                              </select>
                              <button type="button" class="status-confirm-btn" [disabled]="!selectedProjectStatus"
                                (click)="submitProjectStatusUpdate(); documentStatusEditing['__no_docs__'] = false; $event.stopPropagation()">
                                Confirm
                              </button>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Step 3: RRE Approve -->
            <div id="stepper-step-3" class="stepper-step" *ngIf="!fromManageApproval" [class.step-completed]="isStepCompleted(3)"
              [class.step-active]="activeStepperStep === 3 && !isStepCompleted(3)"
              [class.step-locked]="!isStepAccessible(3)" [class.step-current]="activeStepperStep === 3"
              [class.highlight-panel]="highlightStep3">
              <div class="stepper-step-header" (click)="onStepperStepClick(3)">
                <div class="stepper-step-indicator">
                  <div class="step-circle">
                    <mat-icon *ngIf="isStepCompleted(3)">check</mat-icon>
                    <mat-icon *ngIf="!isStepCompleted(3) && !isStepAccessible(3)">lock</mat-icon>
                    <span *ngIf="!isStepCompleted(3) && isStepAccessible(3)">3</span>
                  </div>
                </div>
                <div class="stepper-step-title-area">
                  <div class="stepper-step-label">Step 3</div>
                  <div class="stepper-step-title">RRE Review</div>
                  <div class="stepper-step-summary locked-summary" *ngIf="!isStepAccessible(3)">
                    <mat-icon class="summary-icon">info_outline</mat-icon>
                    Complete Step 2 first
                  </div>
                  <div class="stepper-step-summary completed-summary"
                    *ngIf="isStepCompleted(3) && activeStepperStep !== 3">
                    <mat-icon class="summary-icon">person</mat-icon>
                    Assigned to <strong>{{ getSelectedManagerName() }}</strong>
                  </div>
                </div>
                <mat-icon class="stepper-chevron" *ngIf="isStepAccessible(3)">{{ activeStepperStep === 3 ? 'expand_less'
                  : 'expand_more' }}</mat-icon>
              </div>

              <div class="stepper-step-content" *ngIf="activeStepperStep === 3 && isStepAccessible(3)">
                <div class="stepper-step-body">
                  <div class="assignment-header">
                    <div class="assignment-header-main">
                      <h3 class="panel-title">RRE Review</h3>
                      <div class="assignment-owner-line">
                        <span class="owner-label">Current owner:</span>
                        <span class="owner-value">{{ getSelectedManagerName() ? getSelectedManagerName() : 'Unassigned'
                          }}</span>
                      </div>
                    </div>
                    <button *ngIf="!showManagerAssignmentPanel && !areAllStepsCompleted() && project.subTaskStatus !== 'Pending RAES Review'" type="button"
                      class="btn btn-change-assignee" (click)="toggleManagerAssignmentPanel(true)">
                      <mat-icon>{{ hasAssignedManager(project) ? 'edit' : 'person_add' }}</mat-icon>
                      {{ hasAssignedManager(project) ? 'Change Assignee' : 'Assign Owner' }}
                    </button>
                    <button *ngIf="showManagerAssignmentPanel" type="button" class="btn btn-close-panel-header"
                      (click)="toggleManagerAssignmentPanel()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>

                  <div class="assignment-panel-expanded" *ngIf="showManagerAssignmentPanel">
                    <!-- Step 1: Choose Manager Assignment Type -->
                    <div class="assignment-step" *ngIf="canProceedToAssignment(projectDetail)">
                      <h4 class="step-title">
                        <span class="step-number">1</span>
                        How would you like to assign this approval task?
                      </h4>
                      <div class="assignment-cards-grid">
                        <div class="assignment-card" [class.assignment-card--active]="managerAssignmentMode === 'self'"
                          (click)="setManagerAssignmentMode('self')" role="button" tabindex="0">
                          <div class="card-icon-wrapper">
                            <div class="card-icon">
                              <mat-icon>person_outline</mat-icon>
                            </div>
                          </div>
                          <div class="card-content">
                            <h5 class="card-title">Assign to Myself</h5>
                            <p class="card-description">The approval task will be assigned to your account</p>
                          </div>
                        </div>

                        <div class="assignment-card"
                          [class.assignment-card--active]="managerAssignmentMode === 'others'"
                          (click)="setManagerAssignmentMode('others')" role="button" tabindex="0">
                          <div class="card-icon-wrapper">
                            <div class="card-icon">
                              <mat-icon>group_outline</mat-icon>
                            </div>
                          </div>
                          <div class="card-content">
                            <h5 class="card-title">Assign to a Team Member</h5>
                            <p class="card-description">Select someone from your department</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="!canProceedToAssignment(projectDetail)" class="assignment-step assignment-step-others">
                      <div class="info-box" style="background-color: #fef3c7; border: 1px solid #fcd34d;">
                        <mat-icon style="color: #d97706;">info</mat-icon>
                        <p style="color: #92400e;">{{ (projectDetail?.adminDocuments &&
                          projectDetail?.adminDocuments.length > 0) ? 'Please update the status for all documents before
                          proceeding with RRE review.' : 'Please update the project status before proceeding with RRE
                          review.' }}</p>
                      </div>
                    </div>

                    <!-- Step 2: Self Manager Assignment Confirmation -->
                    <div *ngIf="managerAssignmentMode === 'self' && canProceedToAssignment(projectDetail)"
                      class="assignment-step assignment-step-self" [@.disabled]="false">
                      <h4 class="step-title">
                        <span class="step-number">2</span>
                        Confirm Assignee
                      </h4>
                      <div class="self-assignment-info">
                        <div class="info-box">
                          <mat-icon>info</mat-icon>
                          <p>This approval task will be assigned to your account and you'll approve the submitted
                            documents.</p>
                        </div>
                      </div>
                      <div class="button-group">
                        <button class="btn btn-cancel" (click)="toggleManagerAssignmentPanel()">
                          <span>Cancel</span>
                        </button>
                        <button class="btn btn-confirm-primary" (click)="assignManagerToMember(true)">
                          <span>Confirm</span>
                        </button>
                      </div>
                    </div>

                    <!-- Step 2: Select Manager -->
                    <div *ngIf="managerAssignmentMode === 'others' && canProceedToAssignment(projectDetail)"
                      class="assignment-step assignment-step-others">
                      <h4 class="step-title">
                        <span class="step-number">2</span>
                        Select an RRE
                      </h4>

                      <div class="members-search-wrapper">
                        <input type="text" class="members-search-input" placeholder="Search by name or email..."
                          #managerSearchInput (keyup)="onManagerSearch($event)" />
                        <mat-icon class="search-icon">search</mat-icon>
                      </div>

                      <div class="members-cards-grid">
                        <div *ngFor="let member of getFilteredManagers()" class="member-card"
                          [class.member-card--selected]="selectedManagerId === member.email"
                          (click)="selectManager(member)" role="button" tabindex="0">
                          <div class="member-card-content">
                            <div class="selection-check" *ngIf="selectedManagerId === member.email">
                              <mat-icon>check</mat-icon>
                            </div>
                            <div class="member-details">
                              <h5 class="member-name">{{ member.name }}</h5>
                              <p class="member-job-title">{{ member.jobTitle }}</p>
                              <p class="member-email">{{ member.email }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="getFilteredManagers().length === 0" class="no-members-found">
                        <mat-icon>group_off</mat-icon>
                        <p>No RREs found</p>
                      </div>
                      <div class="button-group">
                        <button class="btn btn-cancel" (click)="toggleManagerAssignmentPanel()">

                          <span>Cancel</span>
                        </button>
                        <button class="btn btn-confirm-primary" [disabled]="!selectedManagerId"
                          (click)="assignManagerToMember()">

                          <span>Confirm : {{ getSelectedManagerName() }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 4: RAES Review -->
            <div class="stepper-step" *ngIf="!fromManageApproval" [class.step-completed]="isStepCompleted(4)"
              [class.step-active]="activeStepperStep === 4 && !isStepCompleted(4)"
              [class.step-locked]="!isStepAccessible(4)" [class.step-current]="activeStepperStep === 4">
              <div class="stepper-step-header" (click)="onStepperStepClick(4)">
                <div class="stepper-step-indicator">
                  <div class="step-circle">
                    <mat-icon *ngIf="isStepCompleted(4)">check</mat-icon>
                    <mat-icon *ngIf="!isStepCompleted(4) && !isStepAccessible(4)">lock</mat-icon>
                    <span *ngIf="!isStepCompleted(4) && isStepAccessible(4)">4</span>
                  </div>
                </div>
                <div class="stepper-step-title-area">
                  <div class="stepper-step-label">Step 4</div>
                  <div class="stepper-step-title">RAES Review</div>
                  <div class="stepper-step-summary locked-summary" *ngIf="!isStepAccessible(4) && !isStepCompleted(4)">
                    <mat-icon class="summary-icon">info_outline</mat-icon>
                    <!-- Awaiting RRE approval -->
                    Complete Step 3 first
                  </div>
                  <div class="stepper-step-summary completed-summary"
                    *ngIf="isStepCompleted(4) && activeStepperStep !== 4">
                    <mat-icon class="summary-icon">check_circle</mat-icon>
                    RAES Review completed
                  </div>
                </div>
                <mat-icon class="stepper-chevron" *ngIf="isStepAccessible(4)">{{ activeStepperStep === 4 ?
                  'expand_less' : 'expand_more' }}</mat-icon>
              </div>

              <div class="stepper-step-content" *ngIf="activeStepperStep === 4 && isStepAccessible(4)">
                <div class="stepper-step-body">
                  <div class="assignment-header">
                    <div class="assignment-header-main">
                      <h3 class="panel-title">RAES Review</h3>
                      <div class="assignment-owner-line">
                        <span class="owner-label">Current owner:</span>
                        <span class="owner-value">{{ projectDetail?.contactPerson || 'Contact Person' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="info-box" *ngIf="!areAllStepsCompleted()" 
                    style="background-color: #eff6ff; border: 1px solid #bfdbfe;">
                    <mat-icon style="color: #2563eb;">info</mat-icon>
                    <p style="color: #1e40af;">The Task will be assigned automatically to the designated contact person of this project for the final review. Once the review is successful, the project will be marked as completed
                      .</p>
                  </div>
                  <div class="raes-status-display" *ngIf="projectDetail?.status === 'Pending RAES Review'">
                    <span class="status-badge-header badge-warning">Pending RAES Review</span>
                  </div>
                  <!-- <div class="raes-status-display" *ngIf="projectDetail?.status === 'Completed'">
                      <span class="status-badge-header badge-success">Completed</span>
                    </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>

    </div>
  </div>

  <ng-template #noProject>
    <div class="access-denied-state" *ngIf="!isLoading">
      <section class="projects-section access-denied-card" aria-labelledby="access-denied-title">
        <div role="status" aria-live="polite">
          <div class="access-denied-icon" aria-hidden="true">
            <mat-icon>lock_outline</mat-icon>
          </div>
          <h1 id="access-denied-title">You don't have access to this page</h1>
          <p class="access-denied-message">Currently you are not authorized to view this page since you are not part of that department.</p>
          <p class="access-denied-message">Please check you used the correct link for your department.</p>
        </div>
        <!-- <div class="access-denied-help">
          <mat-icon aria-hidden="true">info_outline</mat-icon>
          <p>If you believe you should have access, please contact your project administrator to confirm your department assignment.</p>
        </div> -->
        <button type="button" class="btn btn-sm btn-outline-secondary back-btn access-denied-back access-denied-back-primary"
          (click)="goToDashboard()">
          <mat-icon aria-hidden="true">arrow_back</mat-icon>
          Back to Dashboard
        </button>
      </section>
    </div>
  </ng-template>

  <!-- Preview Modal -->

  <!-- Status Updated Success Popup -->
  <div class="status-success-backdrop" *ngIf="showStatusSuccessDialog" (click)="dismissStatusSuccessDialog()">
    <div class="status-success-dialog" (click)="$event.stopPropagation()">
      <div class="status-success-icon-wrap">
        <mat-icon class="status-success-icon">check_circle</mat-icon>
      </div>
      <h3 class="status-success-title">{{ successDialogTitle }}</h3>
      <p class="status-success-message" [innerHTML]="successDialogMessage"></p>
      <div class="status-success-next-step" *ngIf="showNextStep">
        <mat-icon class="next-step-icon">arrow_forward</mat-icon>
        <div class="next-step-content">
          <span class="next-step-label">Next Step</span>
          <span class="next-step-text" *ngIf="!isStepCompleted(3)">Proceed to <strong>Step 3 — RRE Review</strong> to
            assign a reviewer who will review and approve your submitted documents.</span>
          <span class="next-step-text"
            *ngIf="isStepCompleted(3) && !isStepCompleted(4) && projectDetail?.subTaskStatus !== 'APPROVED'">
            Status is now <strong>Pending RRE Review</strong>. Awaiting RRE approval from the dashboard.
          </span>
          <span class="next-step-text"
            *ngIf="isStepCompleted(3) && !isStepCompleted(4) && projectDetail?.subTaskStatus === 'APPROVED'">Proceed to
            <strong>Step 4 —
              RAES Review</strong> for final review.</span>
        </div>
      </div>
      <div class="status-success-actions">
        <button class="btn status-success-btn" type="button" *ngIf="showNextStep && !isStepCompleted(3)"
          (click)="goToRreReviewStep()">
          Assign RRE Reviewer
        </button>
        <button class="btn status-success-btn" type="button" *ngIf="!(showNextStep && !isStepCompleted(3))"
          (click)="dismissStatusSuccessDialog()">Got
          it</button>
      </div>
    </div>
  </div>
  <div class="position-fixed top-0 start-0 end-0 bottom-0 d-flex flex-column preview-overlay" *ngIf="isPreviewOpen">
    <div class="bg-white p-2 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <h6 class="mb-0 text-dark-primary">{{ previewTitle }}</h6>
      </div>
      <div class="d-flex align-items-center gap-3">
        <div *ngIf="previewType === 'xls'" class="d-flex align-items-center gap-2">
          <label class="small text-secondary me-1">Sheet</label>
          <select class="form-select form-select-sm" style="width:auto" [(ngModel)]="selectedSheetIndex"
            (change)="renderSheetByIndex(selectedSheetIndex)">
            <option *ngFor="let s of sheetNames; let i = index" [ngValue]="i">{{ s }}</option>
          </select>
        </div>
        <button
          class="btn btn-light border-0 rounded-2 d-inline-flex align-items-center justify-content-center preview-close-btn"
          (click)="closePreview()" aria-label="Close preview">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="1.4"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>

    <div class="bg-white flex-grow-1 overflow-auto p-2">
      <iframe *ngIf="previewType === 'pdf'" [src]="previewUrl" width="100%" height="100%"></iframe>
      <img *ngIf="previewType === 'image'" [src]="previewUrl" alt="Image preview" class="preview-image" />
      <div *ngIf="previewType === 'docx'" #docxContainer class="h-100 overflow-auto"></div>
      <div *ngIf="previewType === 'xls'" [innerHTML]="excelHtml"></div>
      <!-- <div #webviewerContainer *ngIf="previewType === 'pptx'" style="width:100%;height:100%;min-height:600px;"></div> -->
      <p *ngIf="previewType === 'unsupported'" class="text-center text-secondary">Preview not supported for this file
        type.</p>
    </div>
  </div>
</div>